import NavigationRouter from './navigation/Navigation'
import {useIsRtl} from 'store/Store'
import 'assets/css/font.css'
// import theme from 'services/theme'
// import {StyleSheetManager} from 'styled-components'
// import isPropValid from '@emotion/is-prop-valid'
import {Toaster} from 'sonner'
import {ThemeProvider} from '@mui/material/styles'
import {React} from 'common'
import {CacheProvider} from '@emotion/react'
import {cacheLtr, cacheRtl, createAppTheme, applyCssVariables, COLOR_MODE_STORAGE_KEY} from 'services/theme'
import {getColorValue} from 'appearance'
import useLanguage from 'logic/useLanguage'
import {SideMenuProvider} from 'context/SideMenuContext'
import {useColorMode} from 'context/ColorModeContext'
import {useEffect, useLayoutEffect, useMemo} from 'react'

function App() {
    const isRtl = useIsRtl()
    useLanguage()
    const {mode} = useColorMode()
    useLayoutEffect(() => {
        applyCssVariables(mode)
    }, [mode])

    useEffect(() => {
        localStorage.setItem(COLOR_MODE_STORAGE_KEY, mode)
    }, [mode])

    useEffect(() => {
        if (typeof document === 'undefined') return
        const metaThemeColor = document.querySelector('meta[name="theme-color"]')
        if (!metaThemeColor) return
        const primaryColor = getColorValue('primary')
        if (primaryColor) {
            metaThemeColor.setAttribute('content', primaryColor)
        }
    }, [mode])

    const theme = useMemo(
        () => createAppTheme({mode, direction: isRtl ? 'rtl' : 'ltr'}),
        [mode, isRtl]
    )

    const swipeDirections = useMemo(() => (isRtl ? ['down', 'left'] : ['down', 'right']), [isRtl])

    useLayoutEffect(() => {
        document.body.setAttribute('dir', isRtl ? 'rtl' : 'ltr')
    }, [isRtl])
    return (
        // <StyleSheetManager shouldForwardProp={(prop) => isPropValid(prop)}>
        <CacheProvider value={isRtl ? cacheRtl : cacheLtr}>
            <ThemeProvider theme={theme}>
                <SideMenuProvider>
                    <Toaster
                        theme={mode}
                        dir={isRtl ? 'rtl' : 'ltr'}
                        position="top-center"
                        gap={12}
                        offset={{bottom: 32}}
                        mobileOffset={{bottom: 16, left: 12, right: 12}}
                        swipeDirections={swipeDirections}
                        style={{zIndex: 1400}}
                    />
                    <NavigationRouter />
                </SideMenuProvider>
            </ThemeProvider>
        </CacheProvider>
        // </StyleSheetManager>
    )
}

export default App
